module.exports = __webpack_public_path__ + "img/recurring.17f5e96a.png";